// import Skills from "./Components/Skills.jsx";
import Layout from "./Layout/Layout.jsx";

function App() {
  return (
    <div className="">
      <Layout />
    </div>
  );
}

export default App;
